import React from "react";
import {
	ImageTile,
	ListTile,
	ListTileItem,
	NodeCrumbs,
	TitleContainer,
} from "../../";

const ConfigurationOptions = (props) => {
	const { handleClick, configuration, options, parentSelection, selection } =
		props;

	const maxReached =
		Array.isArray(parentSelection.selection) &&
		parentSelection.maxSelect > 1 &&
		parentSelection.selection.length >= parentSelection.maxSelect;

	const getConflicts = (option) =>
		Array.isArray(option.conflicts) &&
		option.conflicts.length > 0 &&
		option.conflicts.filter((element) => selection.includes(element));

	const getRequires = (option) =>
		Array.isArray(option.requires) &&
		option.requires.length > 0 &&
		option.requires.filter((element) => !selection.includes(element));

	const isOption = (option) => {
		if (parentSelection.selection.includes(option.id)) return true;

		const conflicts = getConflicts(option);
		const requires = getRequires(option);

		if (
			(conflicts && conflicts.length > 0) ||
			(requires && requires.length > 0)
		)
			return false;

		return true;
	};

	return (
		<React.Fragment>
			{configuration ? (
				<TitleContainer title={<NodeCrumbs id={configuration.id} />}>
					<ListTile>
						{options &&
							options
								.filter((op) => isOption(op))
								.map((option, index) => (
									<ListTileItem
										key={`option-${option.id}`}
										index={index}
										length={options.length}
									>
										<ImageTile
											conflicts={getConflicts(option)}
											disabled={
												maxReached &&
												!parentSelection.selection.includes(option.id)
											}
											handleClick={() => handleClick(option)}
											index={index}
											isSelected={parentSelection.selection.includes(option.id)}
											node={option}
											requires={getRequires(option)}
										/>
									</ListTileItem>
								))}
					</ListTile>
				</TitleContainer>
			) : null}
		</React.Fragment>
	);
};

export default ConfigurationOptions;



// WEBPACK FOOTER //
// ./src/modules/configuration/components/configurationOptions.jsx